import firebase from 'firebase/app';

const auth = () => firebase.auth();

auth.getCurrentUser = () => new Promise((resolve, reject) => {
  firebase.auth().onAuthStateChanged((user) => {
    resolve(user);
  }, (error) => {
    reject(error);
  });
});

auth.signInWithCustomToken = (token) => firebase.auth().signInWithCustomToken(token);

export default auth;
